
<template>
  <div align="left" class="brief">
    <Header :hasBack="goback" :hasRight="false">
    </Header>
    <div style="padding: 0 60px; flex: 2; width: 800px; margin: auto">
      <h2 align="center" style="margin-top: 0">License</h2>
      <p>
        Licensed under the Apache License, Version 2.0 (the "License"); you may
        not use this file except in compliance with the License. You may obtain
        a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
        Unless required by applicable law or agreed to in writing, software
        distributed under the License is distributed on an "AS IS" BASIS,
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
        See the License for the specific language governing permissions and
        limitations under the License.
      </p>
    </div>

    <Footer style="width: 800px; margin: auto" />
  </div>
</template>

<script>
import Header from './common/header.vue'
import Footer from './common/footer.vue'
export default {
  name: 'license',
  components: { Footer, Header },
  data () {
    return {
      goback: true
    }
  },
  mounted () {
    if (this.$route.query.goback !== undefined) {
      this.goback = this.$route.query.goback === 1
    }
  },
  methods: {
    goBack () {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.brief {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/license.vue